<script>
  import {mapActions, mapGetters, mapState} from "vuex";
  import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";
  import BusinessWalletNetworkSelect
    from "@/public/components/elements/business-walet/Select/businessWalletNetworkSelect.vue";
  import {
    getCurrencyTicker, getNetworkName, getNetworkShortNameByNetworkName, getNetworkSystemName,
    preparedString,
    prettyAmountWithHideZeros,
    separatePeriods
  } from "@/public/filters";
  import MaxInputElement from "@/public/components/common/uiKit/input/MaxInput.vue";
  import DashboardSwapConfirmation from "@/public/components/modals/dashboard/DashboardSwapConfirmation.vue";
  import DashboardSwapAddressSelectWrapper
    from "@/public/components/elements/dashboard/DashboardSwapAddressSelectWrapper.vue";
  import DashboardCurrencyIcon from "@/public/components/elements/dashboard/DashboardCurrencyIcon.vue";
  import {cryptoColors} from "@/public/components/elements/dashboard/constants";
  import MiniLoader from "@/public/components/common/uiKit/MiniLoader/index.vue";
  import { debounce } from "lodash"

  export default {
    name: "DashboardSwap",
    components: {
      MiniLoader,
      DashboardCurrencyIcon,
      DashboardSwapAddressSelectWrapper,
      DashboardSwapConfirmation,
      MaxInputElement,
      BusinessWalletNetworkSelect,
      BaseButton,
      StoreModal: () => import(/* webpackChunkName: "/public/components/modals/StoreModal" */ '/public/components/modals/StoreModal')
    },
    data() {
      return {
        addressModel: undefined,
        addressModelTo: undefined,
        amountLimitsUSD: {
          min: undefined,
          max: undefined,
        },
        amountFrom: undefined,
        feeToken: undefined,
        swapRate: undefined,
        step: 'form',
        processing: false
      }
    },
    methods: {
      getNetworkName,
      getNetworkShortNameByNetworkName,
      getCurrencyTicker,
      ...mapActions('app', [
        'closeModal',
        'openModal',
      ]),
      ...mapActions('crossChain', [
        'getCrosschainSwapsAmountLimits',
      ]),
      ...mapActions('swap', [
        'getSwapTransferToken',
        'setSwapTransfer'
      ]),
      handleCancelCreate() {
        const {
          closeModal,
        } = this;
        closeModal();
      },
      setNextStep () {
        if (this.step === 'confirm' && !this.processing) {
          this.confirm()
        }
        this.step = 'confirm'
        // debugger;
      },
      async getAmountLimits() {
        const result = await this.getCrosschainSwapsAmountLimits();

        if (result) {
          this.amountLimitsUSD.min = Number(result.min);
          this.amountLimitsUSD.max = Number(result.max);
        }
      },
      async setRecallForToken() {

        if (!this.addressModelTo) return

        const payload = {
          accountId: this.accountId,
          currencyFromId: this.addressModel?.currencyId,
          currencyToId: this.addressModelTo?.currencyId,
          networkFromId: this.addressModel?.networkId,
          networkToId: this.addressModelTo?.networkId,
          amountFrom: !this.amountFrom || (!this.swapRate && this.amountFrom < this.amountLimits.min) ? this.amountLimits.min.toString() : this.amountFrom.toString(),
        }

        const data = await this.getSwapTransferToken(payload)

        if ( !!data.result ) {
          this.feeToken = data.result
          this.swapRate = Number(this.feeToken.price)
        }
      },
      async confirm() {
        this.processing = true

        const payload = {
          accountId: this.accountId,
          clientId: null,
          addressFromId: this.addressModel.id,
          addressToId: this.addressModelTo.id,
          token: this.feeToken.token,
        }

        const result = await this.setSwapTransfer(payload)

        this.processing = false

        this.$emit("swap-result", result)
        this.handleClose()
      },
      clear () {
        this.addressModel = undefined
        this.addressModelTo = undefined
        this.amountLimitsUSD = {
          min: undefined,
          max: undefined
        }
        this.processing = false
        this.amountFrom = undefined
        this.feeToken = undefined
        this.swapRate = undefined
        this.step = 'form'
      }
    },
    computed: {
      cryptoColors() {
        return cryptoColors
      },
      ...mapGetters('dashboard', [
        'availableBalancesAddressesInfo',
      ]),
      ...mapState('accounts', ['accounts']),
      ...mapGetters('app', [
        'isOpenModal',
      ]),
      headerImageLeft() {
        if (!this.addressModel) return '';
        return new URL(`../../elements/dashboard/assets/infoIcons/networks/${this.addressFromNetworkName}.svg`, import.meta.url).href;
      },
      headerImageRight() {
        if (!this.addressModelTo) return '';
        return new URL(`../../elements/dashboard/assets/infoIcons/networks/${this.addressToNetworkName}.svg`, import.meta.url).href;
      },
      ...mapState('app', {
        currencies: state => state.currencies,
        addressId: state => state.modal.payload?.addressId,
        networks: state => state.networks
      }),
      accountId({ accounts }) {
        return accounts.find(({ accountId }) => !!accountId).accountId;
      },
      currentCurrency () {
        return this.currencies.find(({id}) => id === this.addressModel?.currencyId)
      },
      currencyAndNetworkFrom() {
        const network = this.networks.find((item) => item.id === this.addressModel?.networkId)
        const currency = this.currencies.find((item) => item.id === this.addressModel?.currencyId)

        return {
          ...this.addressModel,
          network,
          currency,
        }
      },
      amountLimits({ amountLimitsUSD = {} }) {
        if (!this.addressModel || !this.currentCurrency || !amountLimitsUSD.min || !amountLimitsUSD.max) return {}


        const { usdRate } = this.currentCurrency

        return {
          min: prettyAmountWithHideZeros(amountLimitsUSD.min * 1.02/usdRate, 8),
          max: prettyAmountWithHideZeros(amountLimitsUSD.max * 1.02/usdRate, 8)
        }
      },
      isOpen() {
        const {
          $options: {name},
          isOpenModal,
        } = this;

        return isOpenModal(name);
      },
      select_address() {
        return this.$t('create-withdrawal-request-modal.select_address');
      },
      addressesList() {
      // .filter(b => b.amount !== '0')
        return this.availableBalancesAddressesInfo.filter(item => item.networkInfo.allowCrosschainSwapFrom && item.networkInfo.allowCrosschainSwaps)
            .map(b => ({
              ...b,
              label: `${preparedString(b.address, 7)} | ${separatePeriods(b.amount)} ${getCurrencyTicker(b.currencyId)}`,
              name: this.networks.find(({ id }) => id === b.networkId).name,
              ticker: getNetworkShortNameByNetworkName(this.networks.find(({ id }) => id === b.networkId).name, false),
              currency: getCurrencyTicker(b.currencyId)
            }));
      },
      addressToNetworkName () {
        return getNetworkSystemName(this.addressModelTo?.networkId).toUpperCase()
      },
      addressFromNetworkName () {
        return this.addressModel?.networkInfo.name.toUpperCase()
      },
      isValid() {
        const { min, max } = this.amountLimits;
        const { amountFrom, amountTo, addressFrom, addressTo, availableBalance, currencyAndNetworkFrom, networkTo } = this;

        const form = {
          amountFrom: !!this.amountFrom && availableBalance >= amountFrom,
          // amountTo: !!amountTo && !isNaN(amountTo),
          // addressFrom,
          // currencyAndNetworkFrom,
          // networkTo,
          // addressTo,
          minAmount: !this.amountFrom || amountFrom >= min,
          maxAmount: !this.amountFrom || amountFrom <= max,
        };

        return {
          // forFeeToken: ['currencyAndNetworkFrom', 'networkTo'].every(field => !!form[field]),
          value: Object.keys(form).every(key => {
            return !!form[key];
          }),
          form,
        };
      },
      isSwapDisabled () {
        return !this.addressModelTo || !this.amountFrom || Number(this.amountFrom) < Number(this.amountLimits.min)
      },
      debounceGetToken: ({ setRecallForToken }) => debounce(setRecallForToken, 200),
    },
    watch: {
      isOpen (value) {
        this.$nextTick(async () => {
            this.addressModel = this.addressesList.find(({id}) => this.addressId === id);
            await this.getAmountLimits()
        });
        if (!value) {
          this.clear()
        }
      },
      async addressModelTo  () {
        if (!this.isOpen) return
        await this.setRecallForToken()
      },

      amountFrom () {
        this.debounceGetToken()
      },

      addressModel () {
        this.addressModelTo = undefined;
        this.amountFrom = '';
      }
    }
  }
</script>

<template>
<store-modal
    name="DashboardSwap"
    :loading="processing"
    class="create-business-modal create-withdrawal-request-modal"
    :disableDestroyClose="true"
    :close-btn="false"
    @closeModal="handleCancelCreate"
>
  <template #header>
    <div class="header">
      <div v-if="step !== 'form'" class="close close--back" @click="step = 'form'">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path d="M16.6172 5.37469C16.2286 5.18186 15.7608 5.21461 15.4052 5.45955L7.23856 11.0846C6.93196 11.2957 6.75 11.6367 6.75 12C6.75 12.3633 6.93196 12.7043 7.23856 12.9154L15.4052 18.5404C15.7608 18.7854 16.2286 18.8181 16.6172 18.6253C17.0058 18.4325 17.25 18.0464 17.25 17.625V6.375C17.25 5.95359 17.0058 5.56752 16.6172 5.37469Z" fill="var(--ocp-0-100-primary-primary0)"/>
          </g>
        </svg>

      </div>
      <div class="close close--close" @click="handleCancelCreate">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5" filter="url(#filter0_d_26176_352815)">
            <path d="M8.96967 8.96967C9.26256 8.67678 9.73744 8.67678 10.0303 8.96967L14 12.9393L17.9697 8.96967C18.2626 8.67678 18.7374 8.67678 19.0303 8.96967C19.3232 9.26256 19.3232 9.73744 19.0303 10.0303L15.0607 14L19.0303 17.9697C19.3232 18.2626 19.3232 18.7374 19.0303 19.0303C18.7374 19.3232 18.2626 19.3232 17.9697 19.0303L14 15.0607L10.0303 19.0303C9.73744 19.3232 9.26256 19.3232 8.96967 19.0303C8.67678 18.7374 8.67678 18.2626 8.96967 17.9697L12.9393 14L8.96967 10.0303C8.67678 9.73744 8.67678 9.26256 8.96967 8.96967Z" fill="var(--ocp-0-100-primary-primary0)"/>
          </g>
          <defs>
            <filter id="filter0_d_26176_352815" x="-28" y="-28" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset/>
              <feGaussianBlur stdDeviation="15"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.15 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_26176_352815"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_26176_352815" result="shape"/>
            </filter>
          </defs>
        </svg>

      </div>
      <div class="header-title" v-html="step === 'form' ? $t('payments.swap') : $t('payments.swap-confirmation-title')"></div>
      <div class="header-icon header-icon--left" v-if="addressModel"><DashboardCurrencyIcon class="header-icon-img" :currency="addressModel?.currency" /></div>
      <div class="header-icon header-icon--right" v-if="addressModelTo"><DashboardCurrencyIcon class="header-icon-img" :currency="getCurrencyTicker(addressModelTo?.currencyId)" /></div>
      <div class="header-bg header-bg--left" :style="{ background: `linear-gradient(-270deg, ${cryptoColors[addressFromNetworkName]} -10%, var(--bg-background-secondary) 60%, var(--bg-background-secondary) 100%)` }">
        <img class="header-bg-img header-bg-img--left" :src="headerImageLeft" alt="infoBackground">
      </div>
      <div v-if="addressModelTo" class="header-bg header-bg--right" :style="{ background: `linear-gradient(270deg, ${cryptoColors[addressToNetworkName]} -10%, var(--bg-background-secondary) 60%, var(--bg-background-secondary) 100%)` }">
        <img class="header-bg-img header-bg-img--right" :src="headerImageRight" alt="infoBackground">
      </div>
    </div>
  </template>
  <template #body>
    <div style="position: relative">
      <div v-if="step === 'form'" class="form">
        <div class="line">
          <business-wallet-network-select
              v-model="addressModel"
              :list="addressesList"
              :label="$t('profits.address-from')"
              :placeholer="select_address"
              :show-currency-name="false"
              uniq-key="id"
          />
        </div>
        <div class="line">
          <max-input-element
              v-model="amountFrom"
              :label="$t('swap.amount_input.label')"
              placeholder="0"
              has-action-btn
              :min="amountLimits.min"
              :max="addressModel?.amount"
              @action-btn-click="amountFrom = addressModel.amount"
          >
            <template #label-left>
              {{ $t('profits.amount') }}
            </template>
            <template #bottom-label>
              <div class="limits-wrapper">
                <div
                    class="minimum-amount"
                    :class="{ 'error': !isValid.form.minAmount }"
                >
                    <span class="info">
                      min
                    </span>
                  <span class="value">
                      {{ amountLimits?.min || '~' }} {{ currentCurrency?.currency || 'USD' }}
                    </span>
                </div>
              </div>
            </template>
            <template v-if="addressModel && addressModelTo" #bottom-left-label>
              <div class="limits-wrapper">
                <div
                    class="minimum-amount"
                >
                  <div class="info rate-info">
                    <div class="round-purple"></div>1 {{ addressModel?.currency }} = {{ swapRate }} {{ getCurrencyTicker(addressModelTo?.currencyId) }}
                  </div>
                </div>
              </div>
            </template>
          </max-input-element>
        </div>
        <div class="line separator">
          <div class="separator-line"></div>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.08119 5.71946C2.6665 7.66661 2.6665 10.4442 2.6665 15.9993C2.6665 21.5545 2.6665 24.3321 4.08119 26.2792C4.53808 26.9081 5.0911 27.4611 5.71995 27.918C7.6671 29.3327 10.4447 29.3327 15.9998 29.3327C21.555 29.3327 24.3326 29.3327 26.2797 27.918C26.9086 27.4611 27.4616 26.9081 27.9185 26.2792C29.3332 24.3321 29.3332 21.5545 29.3332 15.9993C29.3332 10.4442 29.3332 7.66661 27.9185 5.71946C27.4616 5.09061 26.9086 4.53759 26.2797 4.0807C24.3326 2.66602 21.555 2.66602 15.9998 2.66602C10.4447 2.66602 7.6671 2.66602 5.71995 4.0807C5.0911 4.53759 4.53808 5.09061 4.08119 5.71946ZM18.9035 8.44169C19.3226 8.02094 19.8344 7.62288 20.5158 7.51431C20.6556 7.49204 20.7968 7.48083 20.9382 7.48083C21.0797 7.48083 21.2208 7.49204 21.3606 7.51431C22.042 7.62288 22.5538 8.02094 22.973 8.44168C23.3769 8.84723 23.8228 9.40955 24.3397 10.0615L25.7595 11.8522C26.1407 12.3331 26.06 13.0319 25.5792 13.4132C25.0983 13.7945 24.3995 13.7137 24.0182 13.2329L22.6376 11.4917C22.413 11.2084 22.2198 10.9651 22.0493 10.7555L22.0493 22.4191C22.0493 23.0328 21.5519 23.5302 20.9382 23.5302C20.3246 23.5302 19.8271 23.0328 19.8271 22.4191L19.8271 10.7555C19.6567 10.9651 19.4634 11.2085 19.2388 11.4917L17.8583 13.2329C17.477 13.7137 16.7781 13.7945 16.2973 13.4132C15.8164 13.0319 15.7357 12.3331 16.117 11.8522L17.5368 10.0616C18.0537 9.40957 18.4995 8.84724 18.9035 8.44169ZM12.1727 9.57935C12.1727 8.9657 11.6752 8.46824 11.0616 8.46824C10.4479 8.46824 9.95045 8.9657 9.95045 9.57935L9.95046 21.2429C9.78003 21.0333 9.58675 20.79 9.36218 20.5068L7.98159 18.7656C7.60033 18.2847 6.90146 18.204 6.42062 18.5853C5.93978 18.9665 5.85905 19.6654 6.24031 20.1462L7.66012 21.9369C8.17703 22.5889 8.62285 23.1512 9.02684 23.5568C9.44596 23.9775 9.95777 24.3756 10.6392 24.4841C10.779 24.5064 10.9201 24.5176 11.0616 24.5176C11.203 24.5176 11.3442 24.5064 11.484 24.4841C12.1654 24.3756 12.6772 23.9775 13.0963 23.5568C13.5003 23.1512 13.9461 22.5889 14.463 21.9369L15.8828 20.1462C16.2641 19.6654 16.1834 18.9665 15.7025 18.5853C15.2217 18.204 14.5228 18.2847 14.1415 18.7656L12.761 20.5068C12.5364 20.79 12.3431 21.0333 12.1727 21.2429L12.1727 9.57935Z" fill="#744DB2"/>
          </svg>
          <div class="separator-line"></div>
        </div>
        <dashboard-swap-address-select-wrapper v-model="addressModelTo" :address-from="addressModel?.address || ''" :currency-and-network-from="currencyAndNetworkFrom" />
      </div>
      <dashboard-swap-confirmation v-else :fee-token="feeToken" :swapRate="swapRate" :addressFromObj="addressModel" :addressToObj="addressModelTo" />
    </div>
  </template>
  <template #footer>
    <div class="swap-footer">
      <base-button v-if="step !== 'form'" :label="$t('payments.cancel')"  type="secondary" @click="handleCancelCreate"></base-button>
      <base-button :disabled="isSwapDisabled"  type="primary" @click="setNextStep">
        <template #label>
          <span class="label">{{ step === 'form' ? $t('payments.swap') : $t('payments.confirm') }}</span>
        </template>
      </base-button>
    </div>
  </template>
</store-modal>
</template>

<style scoped lang="scss">
.swap-footer {
  display: flex;
  align-items: center;
  gap: 20px;
}
.loading {
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.close {
  position: absolute;
  top: -20px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid var(--border-border-input-primary-default, #E0E2E7);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &::before {
    content: '';
    opacity: 0.65;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--bg-background-secondary);
    backdrop-filter: blur(10px) opacity(0.65);
    position: absolute;
    z-index: -1;
  }
  &--back {
    left: -20px;
  }
  &--close {
    right: -20px;
  }
}
.header {
  position: relative;
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: $Gilroy;
  &-title {
    position: relative;
    z-index: 2;
    color: var(--text-text-primary, #000);
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: 0.38px;
  }
  &-bg {
    position: absolute;
    z-index: 0;
    top: -30px;
    width: 50%;
    height: 145px;
    &-img {
      position: absolute;
      top: -95px;
      width: 320px;
      height: 320px;
      &--left {
        left: -70px;
      }
      &--right {
        right: -70px;
      }
    }
    &--right {
      right: -30px;
    }
    &--left {
      left: -30px;
    }
  }
  &-icon {
    position: relative;
    z-index: 2;
    width: 62px;
    height: 62px;
    padding: 10px;
    border-radius: 50%;
    //
    display: flex;
    justify-content: center;
    align-items: center;
    &-img {
      z-index: 2;
    }
    &:before {
      content: '';
      position: absolute;
      background: var(--bg-background-secondary);
      z-index: 1;
      width: 62px;
      height: 62px;
      border-radius: 50%;
      opacity: 0.65;
      filter: drop-shadow(0px 25px 20px rgba(10, 17, 105, 0.30));
    }
    &--left {
      position: absolute;
      left: 0;
      transform: translateY(50%);
    }
    &--right {
      position: absolute;
      right: 0;
      transform: translateY(50%);
    }
  }
}
.content {
  padding: 0 30px;
  font-family: $Gilroy;
}
.form {
  padding: 30px;
}
.main-modal-footer {
  padding: 30px;
}
.line {
  margin-bottom: 15px;
}
.separator-line {
  background: var(--border-devider-primary);
  height: 1px;
  width: 100%;
}
.separator {
  display: grid;
  grid-template-columns: 1fr 32px 1fr;
  align-items: center;
  gap: 10px;
  margin-top: 60px;
  margin-bottom: 30px;
  svg {
    width: 32px;
    height: 32px;
  }
}
.minimum-amount,.maximum-amount {
  .info {
    color: var(--text-color-text-secondary, #8B81A0);
    font-size: 16px;
    font-weight: 500;
  }
  .value {
    color: var(--text-text-primary, #000);
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
  }
  &.error {
    .info {
      color: red;
    }
    .value {
      color: red;
    }
  }
}
.amount-input {
  .label-right {
    .available-balance {
      font-style: normal;
      font-weight: 400;

      text-align: center;

      color: var(--new-front-secondary-font-color);

      .value {
        color: var(--new-front-primary-font-color);
      }
    }
  }
  .bottom-label {
    display: flex;
    justify-content: right;

    font-family: var(--new-front-font-family);
    font-style: normal;
    font-weight: 500;

    .limits-wrapper {
      width: 100%;
      display: flex;
      justify-content: end;

      gap: $h6;

      .minimum-amount,.maximum-amount {
        &.error {
          .info {
            color: red;
          }
          .value {
            color: red;
          }
        }
      }

      @include below_phone() {
        display: none;
      }
    }



    .available-balance {
      display: none;

      @include below_phone() {
        width: 100%;
        display: flex;
        justify-content: end;
      }

      .info {
        color: var(--new-front-secondary-font-color);
        margin-right: $h6;
      }
    }

    .info {
      color: var(--new-front-secondary-font-color);
    }
    .value {
      color: var(--new-front-primary-font-color);
    }
  }
}
::v-deep {
  .base-max-input .input-wrapper .action {
    height: 34px !important;
    width: 57px !important;
    border-radius: 8px;
    background: var(--bg-background-table, #F4F0FE);
    padding: 7px 12px;
    font-size: 16px;
    font-weight: 500;
    border-left: 0;
    margin-right: 7px;
  }
  .base-max-input .input-wrapper .bottom-left-label {
    top: 47px;
  }
}
.round-purple {
  width: 5px;
  height: 5px;
  background: var(--bg-background-primary-purple);
  border-radius: 50%;
  margin-right: 4px;
}
.rate-info {
  display: flex;
  align-items: center;
}
::v-deep {
  .main-modal-header {
    overflow: hidden;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    max-height: 145px !important;
    border-bottom: 1px dashed var(--border-devider-primary);
  }
}
@media screen and (max-width: 576px) {

  .content {
    padding: 0 20px;
  }
  .form {
    padding: 20px;
  }
  .header-title {
    font-size: 20px;
  }
  .action {
    font-size: 13px;
  }
  .minimum-amount {
    font-size: 13px;
  }
  .minimum-amount .info {
    font-size: 13px;
  }
  .minimum-amount .value {
    font-size: 13px;
  }
  ::v-deep {
    .base-max-input .input-wrapper .action {
      font-size:  13px !important;
    }
  }
}
</style>
